import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
// Component
import SubTasks from './SubTasks';
import {
  createTask,
  deleteTask,
  duplicateTask,
  getTaskLocation,
  getSubTasks,
  getDefaultSubTasks,
  exportAllSubtaskPublicZoneReport,
} from '../tasksActions';
import { getMainTaskList } from '../EmtithalMasterTasks/emtithalMasterTasksActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  publicZoneList: state.office.publicZoneList,
  duplicateIsLoading: state.task.duplicateIsLoading,
  locationsList: state.task.locationsList,
  deleteIsLoading: state.task.deleteIsLoading,
  deletedCallback: state.task.deletedCallback,
  subTasksList: state.task.subTasksList,
  defaultSubTasks: state.task.defaultSubTasks,
  createdTaskInfo: state.task.createdTaskInfo,
  overlap: state.task.overlap,
  duplicateTaskInfo: state.task.duplicateTaskInfo,
  isLoading: state.task.isLoading,
  loadingTaskAssigneeId: state.project.loadingTaskAssigneeId,
  // pagination
  totalTasksCount: state.task.tasksListCount,
  pageSize: state.task.taskListPageSize,
  mainTaskList: state.task.mainTaskList,
  emtithalMasterTasksList: state.task.emtithalMasterTasksList,
  exportAllSubtaskPublicZoneReportLoading: state.task.exportAllSubtaskPublicZoneReportLoading,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getSubTasks: params => dispatch(getSubTasks(params)),
  getDefaultSubTasks: params => dispatch(getDefaultSubTasks(params)),
  createTask: params => dispatch(createTask(params)),
  deleteTask: params => dispatch(deleteTask(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getMainTaskList: params => dispatch(getMainTaskList(params)),
  getEmtithalMasterTasks: params => dispatch(getEmtithalMasterTasks(params)),
  exportAllSubtaskPublicZoneReport: params => dispatch(exportAllSubtaskPublicZoneReport(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(SubTasks);
